import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import testimonials from "./Partner/testimonialsData";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { Button } from "@material-ui/core";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const SuccessStories = () => {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  return (
    <div className="min-h-screen w-screen bg-emerald-400">
      <Typography
        variant="h2"
        component="h2"
        sx={{
          color: "white",
          fontWeight: "bold",
          textAlign: "center",
          pt: 10,
          pb: 1,
          mx: "auto",
        }}
      >
        Success Stories
      </Typography>
      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{
          color: "white",
          textAlign: "justify",
          pt: 1,
          pb: 3,
          lineHeight: 1.2,
          m: "auto",
          maxWidth: "800px",
        }}
      >
        Read the{" "}
        <a
          href="https://www.iitmaa.org/f/mock-interview-12582"
          className="font-semibold underline text-blue-600 hover:text-blue-800"
        >
          Blog Article
        </a>{" "}
        on the role of Fyzen Career Solutions Pvt Ltd (creator of interwiu.com)
        in the success of below students by conducting Mock Interviews (with
        Feedback Sessions) before the Campus Placements (2021-22) at IIT Madras:
        published by <b> IIT Madras Alumni Association</b>
      </Typography>

      <div className="my-auto mx-auto max-w-xs sm:max-w-xl lg:max-w-4xl">
        <Carousel
          selectedItem={count}
          showArrows={false}
          infiniteLoop={true}
          showIndicators={false}
          showThumbs={false}
          showStatus={false}
          autoPlay={true}
          interval={3000}
          onChange={(e) => setCount(e)}
        >
          {testimonials.map((testimonial, index) => {
            return (
              <div>
                <div
                  className="text-black rounded-lg bg-white p-3 grid grid-cols-4 gap-3"
                  style={{ height: "340px" }}
                  key={index}
                  id="testimonial"
                >
                  <div className="col-span-1 my-auto ">
                    <div
                      className="rounded-3xl m-3 mx-auto overflow-hidden border border-8 border-emerald-400"
                      style={{ height: "169px", width: "169px" }}
                    >
                      <img
                        src={require("../../images/testimonial-image/" +
                          testimonial.name +
                          ".jpg")}
                        className="object-cover"
                        alt="Person"
                      />
                    </div>
                    <div className="text-center">
                      <Typography
                        variant="h5"
                        component="h5"
                        sx={{ fontWeight: "bold" }}
                      >
                        {testimonial.name}
                      </Typography>
                    </div>
                  </div>
                  <div className="col-span-3 my-auto text-left">
                    <Typography
                      variant="body1"
                      sx={{ m: 0, fontSize: "18px" }}
                      gutterBottom
                    >
                      {testimonial.degree} <b> IIT Madras</b>, 2022
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: "18px" }}
                      gutterBottom
                    >
                      Placed at <b>{testimonial.placedIn}</b> as{" "}
                      <b>{testimonial.position}</b>
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      sx={{
                        textAlign: "justify",
                        lineHeight: 1.2,
                      }}
                    >
                      <i class="fa-solid fa-quote-left text-red-400"></i>{" "}
                      <div id="line-clamp">{testimonial.comment}</div>{" "}
                      <i class="fa-solid fa-quote-right text-red-400"></i>
                    </Typography>
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
        <div className="my-1 flex justify-center">
          <IconButton
            aria-label="Previous"
            size="large"
            onClick={() => {
              setCount((prevState) => (prevState === 0 ? 22 : prevState - 1));
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>
          <IconButton
            aria-label="Next"
            size="large"
            onClick={() => {
              setCount((prevState) => (prevState === 22 ? 0 : prevState + 1));
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        </div>
        <div className="flex justify-center pb-4">
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              navigate("/testimonials");
            }}
          >
            See All Success Stories
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuccessStories;
